import Component from './component'

export default Component



// WEBPACK FOOTER //
// ./src/components/SitesResultsGrid/index.js